// Login-related types
export type LoginStep = "phone" | "otp" | "verified";
export type OtpMethod = "sms" | "whatsapp";

// Utility function to format phone numbers
export const formatPhoneNumber = (phone: string, countryCode: string): string => {
	const cleaned = phone.replace(/[^\d+]/g, "");
	const countryCodeDigits = countryCode.replace(/[^\d+]/g, "");

	// If phone already starts with +, return as-is
	if (cleaned.startsWith("+")) {
		return cleaned;
	}

	// If phone already starts with country code digits (without +), add +
	if (cleaned.startsWith(countryCodeDigits.replace("+", ""))) {
		return "+" + cleaned;
	}

	// Otherwise, prepend country code
	return countryCode + cleaned;
};

// Utility function to validate phone number
export const isValidPhoneNumber = (phone: string, countryCode: string): boolean => {
	const cleaned = phone.replace(/[^\d+]/g, "");
	const minLength = ["+1", "+91"].includes(countryCode) ? 10 : 5;
	return cleaned.length >= minLength && cleaned.length <= 15;
};

export const isPhoneNumberValid = (phone: string, countryCode: string): boolean => {
	const cleaned = phone.replace(/[^\d+]/g, "");
	let result = false;
	const minLength = ["+1", "+91"].includes(countryCode) ? 10 : 5;
	if (countryCode.includes("+91")) result = phone?.replace(/^\+91/, "")?.length === 10;
	else result = cleaned.length >= minLength && cleaned.length <= 15;
	return result;
};

// Utility function to validate OTP
export const isValidOtp = (otp: string): boolean => {
	return /^\d{5}$/.test(otp);
};

// Get OTP method display name
export const getOtpMethodDisplayName = (method: OtpMethod): string => {
	return method === "whatsapp" ? "WhatsApp" : "SMS";
};
